import React from 'react';
import { useTranslation } from 'react-i18next';
import readableFileSize from 'filesize';
import ConditionalWrapper from '../../../../../ConditionalWrapper';
import { DownloadType } from '../utils';
import RadioButton from '@wix/da-ds/pkg/RadioButton';
import { formatDollars } from '../../../../../utils/formatting';
import s from './DownloadOptions.scss';
var DownloadOptions = function (_a) {
    var pcp = _a.pcp, download = _a.download, selectedType = _a.selectedType, hasAccessViaSubscription = _a.hasAccessViaSubscription, onSelect = _a.onSelect;
    var t = useTranslation().t;
    var fileTypesIncluded = (pcp.assets || [])
        .map(function (asset) { return asset.type && asset.type.toLocaleUpperCase(); })
        .filter(function (type, index, array) { return type && array.indexOf(type) === index; })
        .join(' ');
    var dollarPrice = formatDollars(pcp.downloadDollarPrice);
    var titleWithPrice = t(pcp.downloadPrice && pcp.downloadPrice < 80
        ? 'pcp.buyForPoints'
        : 'pcp.buyForCurrency', {
        price: pcp.downloadPrice,
        dollars: dollarPrice,
    });
    var pcpOptionTitle = pcp.hasUserPurchased
        ? t('pcp.purchased')
        : titleWithPrice;
    if (hasAccessViaSubscription) {
        pcpOptionTitle = t('actionbar.pcp.purchasedThroughSubscription');
    }
    var hasFreeDownload = !!download;
    return (React.createElement("div", { className: s['options'] },
        hasFreeDownload && (React.createElement(RadioButton, { className: s['option'], name: "download", size: "small", value: DownloadType.FREE, checked: selectedType === DownloadType.FREE, onChange: onSelect, withMargins: true },
            React.createElement("div", { className: s['text-block'] },
                React.createElement("div", { className: s['title'] }, t('pcp.free', {
                    size: download.width + "x" + download.height,
                }))))),
        React.createElement(ConditionalWrapper, { condition: hasFreeDownload, wrap: function (children) { return (React.createElement(RadioButton, { className: s['option'], name: "download", value: DownloadType.PREMIUM, onChange: onSelect, checked: selectedType === DownloadType.PREMIUM, size: "small", withMargins: true }, children)); } },
            React.createElement("div", { className: s['text-block'] },
                React.createElement("div", { className: s['title'] }, pcpOptionTitle),
                React.createElement("div", { className: s['subtitle'] }, t('pcp.zipFileDetails', {
                    size: readableFileSize(pcp.zipFilesize || 0),
                    types: fileTypesIncluded,
                }))))));
};
DownloadOptions.displayName = 'DownloadOptions';
export default DownloadOptions;
//# sourceMappingURL=DownloadOptions.js.map